import { AlignmentType, HeadingLevel, ImageRun, Paragraph, TextRun, WidthType } from 'docx';
import fourthimg from '../../../../../../Assests/ReportImages/image4.png'
import methodology from '../../../../../../Assests/ReportImages/approachMethodology.png'
const heading4 = await fetch(fourthimg).then(response => response.blob())
const setupMethodology = await fetch(methodology).then(response => response.blob())

const imagefour = new ImageRun({
    type: 'png',
    data: await heading4.arrayBuffer(),
    transformation: {
        width: 150,
        height: 120
    },
});

export const imageFour = new Paragraph({
    indent: { left: 130 },
    spacing: { before: 400 },
    alignment: AlignmentType.LEFT,
    children: [imagefour]
})

export const methodologyHeading = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 100 },
    children: [
        new TextRun({
            text: "4. Approach & Methodology",
            size: 40,
            color: "0189f9",
            font: "Gill Sans MT",
            bold: true,
            italics: false
        })
    ],
    heading: HeadingLevel.HEADING_2,
})


export const methodologyText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 350, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The primary source of increase of attacks on applications is because of insecure coding practices.  Secure code review can identify, prioritize and mitigate vulnerabilities in the deployed applications as well as applications that are under development stage. Security code review methodology has evolved from its strong application development experience, affiliation to international research forums and practice of internal standards. The following section captures the code review methodology followed by ISECURION.",
            size: 24,
            font: "Calibri",
            color: '0f0f3f',
            italics: false,
            bold: false
        }),
    ],
})

const approachMethodology = new ImageRun({
    type: 'png',
    data: await setupMethodology.arrayBuffer(),
    transformation: {
        width: 600,
        height: 350
    },
});

export const setUpAndMethodology = new Paragraph({
    indent: { left: 130 },
    spacing: { before: 350 },
    alignment: AlignmentType.CENTER,
    children: [approachMethodology]
})